<template>
  <div class="container py-5 internet-page">

    <!-- Title -->
    <h2 class="page-title mb-4">Internet & Network</h2>

    <!-- Description -->
    <p class="lead">
      This lesson explains the basics of the Internet, networking concepts, 
      devices, and how computers communicate with each other globally.
    </p>

    <!-- Section 1 -->
    <div class="card-section mt-4">
      <h4 class="section-title">🌐 What is the Internet?</h4>
      <p>
        The Internet is a global network of millions of interconnected computers 
        that share information using standard communication rules called protocols.
      </p>
    </div>

    <!-- Section 2 -->
    <div class="card-section mt-4">
      <h4 class="section-title">🔗 What is a Network?</h4>
      <p>
        A network is a group of two or more computers connected together to 
        share resources such as data, internet, printers, and applications.
      </p>
    </div>

    <!-- Section 3 -->
    <div class="card-section mt-4">
      <h4 class="section-title">🧰 Types of Networks</h4>
      <ul>
        <li><strong>LAN (Local Area Network):</strong> Covers a small area like a home or school.</li>
        <li><strong>WAN (Wide Area Network):</strong> Covers a large geographical area, like countries.</li>
        <li><strong>MAN (Metropolitan Area Network):</strong> Covers a city or town.</li>
      </ul>
    </div>

    <!-- Section 4 -->
    <div class="card-section mt-4">
      <h4 class="section-title">📡 Common Network Devices</h4>
      <ul>
        <li><strong>Router:</strong> Connects multiple networks together.</li>
        <li><strong>Switch:</strong> Connects devices within a LAN.</li>
        <li><strong>Modem:</strong> Connects home/office to the Internet.</li>
        <li><strong>Access Point:</strong> Provides wireless network (Wi-Fi).</li>
      </ul>
    </div>

    <!-- Section 5 -->
    <div class="card-section mt-4">
      <h4 class="section-title">⚙ How the Internet Works</h4>
      <ul>
        <li>Data is broken into packets.</li>
        <li>Packets travel through routers and networks.</li>
        <li>Each device uses an IP address for identification.</li>
        <li>Servers provide websites, emails, and online services.</li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: "InternetNetwork",
};
</script>

<style scoped>
.page-title {
  font-weight: 800;
  color: #2563eb;
}

.lead {
  color: #374151;
  font-size: 1.1rem;
}

.card-section {
  background: #ffffff;
  padding: 20px 24px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-left: 4px solid #2563eb;
}

.section-title {
  color: #1e40af;
  font-weight: 600;
}
</style>
